import { useEffect } from 'react';
import useVoiceRecorder from '@/hooks/useVoiceRecorder';
import Mic from '../icons/Mic';
interface Props {
  postType?: string;
  callBack?: (arg: Blob) => void;
}
const VoiceRecorder = ({
  callBack
}: Props) => {
  const {
    audio,
    isRecording,
    toggleRecording
  } = useVoiceRecorder();
  useEffect(() => {
    if (callBack && audio) {
      callBack(audio);
    }
  }, [audio, callBack]);
  return <button className="bg-primary-100 rounded-full p-3 flex justify-center items-center h-[calc(100%-2px)]" aria-label="Record audio message" onClick={toggleRecording} data-testid="comments-bar-voice-recorder" data-sentry-component="VoiceRecorder" data-sentry-source-file="VoiceRecorder.tsx">
      <Mic className={`${isRecording ? 'stroke-error-100' : 'stroke-white'} fill-transparent h-6 w-[25px] `} data-sentry-element="Mic" data-sentry-source-file="VoiceRecorder.tsx" />
    </button>;
};
export default VoiceRecorder;